import api from './api'

export const recordingService = {
  /**
   * 上传录音文件
   */
  uploadRecording(file, duration = 0) {
    const formData = new FormData()
    formData.append('audioFile', file)
    formData.append('duration', duration)
    
    return api.post('/recording/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 300000 // 5分钟超时，因为文件上传可能需要较长时间
    })
  },
  
  /**
   * 语音转文字
   */
  transcribeRecording(recordId) {
    return api.post('/recording/transcribe', { recordId }, {
      timeout: 300000 // 5分钟超时，转写可能需要较长时间
    })
  },
  
  /**
   * 获取录音列表
   */
  getRecordingList() {
    return api.get('/recording/list')
  },
  
  /**
   * 获取录音详情
   */
  getRecordingDetail(id) {
    return api.get(`/recording/detail/${id}`)
  },
  
  /**
   * 生成纪要
   */
  generateSummary(recordId) {
    return api.post('/recording/summary', { recordId }, {
      timeout: 60000 // 1分钟超时
    })
  },
  
  /**
   * 删除录音
   */
  deleteRecording(id) {
    return api.delete(`/recording/${id}`)
  }
}
